var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/024e93dea79aaa8fafaf191aa5395a47.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/260b81bd045916dba4d8751d08c5f2ba.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/326dd8d082bb55160bda2d6be117c5ad.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698837f6411f07a2a76091781fc8a00f.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9903490e332e85b74c7fd3eba65f92b9.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b66f03281ca6722da3ac90a11b7da004.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e9b5e10a199991cba39f82666ab690af.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    